<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号">
                <a-input v-model="queryParam.orderNo" placeholder="请输入订单号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userPhone" placeholder="请输入用户手机号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="支付状态">
                <a-select v-model="queryParam.payStatus" placeholder="请选择支付状态" allow-clear>
                  <a-select-option :value="0">待支付</a-select-option>
                  <a-select-option :value="1">已支付</a-select-option>
                  <a-select-option :value="2">已取消</a-select-option>
                  <a-select-option :value="3">已退款</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :bordered="tableBordered"
      >
        <span slot="payStatus" slot-scope="text, record">
          <a-tag :color="getPayStatusColor(record.payStatus)">
            {{ record.payStatusName }}
          </a-tag>
        </span>
        <span slot="orderAmount" slot-scope="text, record">
          ¥{{ (record.orderAmount / 100).toFixed(2) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="payTime" slot-scope="text, record">
          {{ record.payTime ? parseTime(record.payTime) : '-' }}
        </span>
        <span slot="expireTime" slot-scope="text, record">
          {{ record.expireTime ? parseTime(record.expireTime) : '-' }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['plus:order:query']">
            <a-icon type="eye" />详情
          </a>
          <a-divider type="vertical" v-if="record.payStatus === 0" v-hasPermi="['plus:order:edit']" />
          <a v-if="record.payStatus === 0" @click="handleCancel(record)" v-hasPermi="['plus:order:edit']">
            <a-icon type="close" />取消
          </a>
        </span>
      </a-table>
    </a-card>

    <!-- 订单详情 -->
    <a-modal
      title="订单详情"
      :width="800"
      :visible="detailVisible"
      :footer="null"
      @cancel="detailVisible = false"
    >
      <a-descriptions :column="2" bordered>
        <a-descriptions-item label="订单号" :span="2">
          {{ detailData.orderNo }}
        </a-descriptions-item>
        <a-descriptions-item label="用户昵称">
          {{ detailData.userName }}
        </a-descriptions-item>
        <a-descriptions-item label="用户手机号">
          {{ detailData.userPhone }}
        </a-descriptions-item>
        <a-descriptions-item label="会员等级">
          {{ detailData.levelName }}
        </a-descriptions-item>
        <a-descriptions-item label="订单金额">
          ¥{{ (detailData.orderAmount / 100).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="支付状态">
          <a-tag :color="getPayStatusColor(detailData.payStatus)">
            {{ detailData.payStatusName }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="支付时间">
          {{ detailData.payTime ? parseTime(detailData.payTime) : '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="到期时间">
          {{ detailData.expireTime ? parseTime(detailData.expireTime) : '-' }}
        </a-descriptions-item>
        <a-descriptions-item label="创建时间" :span="2">
          {{ parseTime(detailData.createTime) }}
        </a-descriptions-item>
        
        <a-descriptions-item label="分销用户" :span="2" v-if="detailData.commissionUserName">
          {{ detailData.commissionUserName }}
        </a-descriptions-item>
        <a-descriptions-item label="分销奖励" v-if="detailData.commissionAmount">
          ¥{{ (detailData.commissionAmount / 100).toFixed(2) }}
        </a-descriptions-item>
        <a-descriptions-item label="奖励状态" v-if="detailData.commissionStatus !== undefined">
          <a-tag :color="getCommissionStatusColor(detailData.commissionStatus)">
            {{ getCommissionStatusText(detailData.commissionStatus) }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="发放时间" :span="2" v-if="detailData.commissionGrantTime">
          {{ detailData.commissionGrantTime }}
        </a-descriptions-item>
      </a-descriptions>
      
      <div style="margin-top: 20px; text-align: center" v-if="detailData.commissionStatus === 0 && detailData.payStatus === 1">
        <a-button type="primary" @click="handleGrantCommission" :loading="grantLoading">
          <a-icon type="gift" />发放分销奖励
        </a-button>
      </div>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pageList, detail, cancelOrder, grantCommission } from '@/api/plus/plusOrder'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'PlusOrder',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      queryParam: {
        orderNo: undefined,
        userPhone: undefined,
        payStatus: undefined
      },
      detailVisible: false,
      detailData: {},
      grantLoading: false,
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderNo',
          width: 180,
          ellipsis: true
        },
        {
          title: '用户昵称',
          dataIndex: 'userName',
          width: 120,
          ellipsis: true
        },
        {
          title: '用户手机号',
          dataIndex: 'userPhone',
          width: 120,
          align: 'center'
        },
        {
          title: '会员等级',
          dataIndex: 'levelName',
          width: 100
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmount',
          scopedSlots: { customRender: 'orderAmount' },
          width: 100,
          align: 'right'
        },
        {
          title: '支付状态',
          dataIndex: 'payStatus',
          scopedSlots: { customRender: 'payStatus' },
          width: 100,
          align: 'center'
        },
        {
          title: '支付时间',
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          width: 180,
          align: 'center'
        },
        {
          title: '到期时间',
          dataIndex: 'expireTime',
          scopedSlots: { customRender: 'expireTime' },
          width: 180,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 180,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 150,
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    /** 查询列表 */
    getList() {
      this.loading = true
      pageList({
        ...this.queryParam,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(response => {
        this.list = response.data.records
        this.pagination.total = response.data.total
        this.loading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        orderNo: undefined,
        userPhone: undefined,
        payStatus: undefined
      }
      this.handleQuery()
    },
    /** 查看详情 */
    handleDetail(row) {
      this.detailVisible = true
      this.detailData = {}
      detail(row.id).then(response => {
        this.detailData = response.data
      })
    },
    /** 取消订单 */
    handleCancel(row) {
      this.$confirm({
        title: '确认',
        content: '是否确认取消订单"' + row.orderNo + '"?',
        onOk: () => {
          return cancelOrder(row.id).then(() => {
            this.getList()
            this.$message.success('取消成功')
          })
        }
      })
    },
    /** 发放分销奖励 */
    handleGrantCommission() {
      this.$confirm({
        title: '确认',
        content: '是否确认发放分销奖励?',
        onOk: () => {
          this.grantLoading = true
          return grantCommission(this.detailData.id).then(() => {
            this.grantLoading = false
            this.handleDetail(this.detailData)
            this.getList()
            this.$message.success('发放成功')
          }).catch(() => {
            this.grantLoading = false
          })
        }
      })
    },
    /** 获取支付状态颜色 */
    getPayStatusColor(status) {
      const colorMap = {
        0: 'orange',
        1: 'green',
        2: 'red',
        3: 'red'
      }
      return colorMap[status] || 'default'
    },
    /** 获取分销奖励状态颜色 */
    getCommissionStatusColor(status) {
      const colorMap = {
        0: 'orange',
        1: 'green',
        2: 'red'
      }
      return colorMap[status] || 'default'
    },
    /** 获取分销奖励状态文本 */
    getCommissionStatusText(status) {
      const textMap = {
        0: '待发放',
        1: '已发放',
        2: '已取消'
      }
      return textMap[status] || '未知'
    }
  }
}
</script>
